import { render, staticRenderFns } from "./OutOrd.vue?vue&type=template&id=76eb7f1e&scoped=true"
import script from "./OutOrd.vue?vue&type=script&lang=js"
export * from "./OutOrd.vue?vue&type=script&lang=js"
import style0 from "./OutOrd.vue?vue&type=style&index=0&id=76eb7f1e&lang=scss&scoped=true"
import style1 from "./OutOrd.vue?vue&type=style&index=1&id=76eb7f1e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eb7f1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76eb7f1e')) {
      api.createRecord('76eb7f1e', component.options)
    } else {
      api.reload('76eb7f1e', component.options)
    }
    module.hot.accept("./OutOrd.vue?vue&type=template&id=76eb7f1e&scoped=true", function () {
      api.rerender('76eb7f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/OutOrd.vue"
export default component.exports